import { create } from "zustand";

export const useClickStore =  create((set)=>({
    clickType:'pan',
    setClickType:(clickType_)=>{set((state)=>({
        clickType:clickType_,
        instanceId:null
    }))},
    measure_points:[],
    setClickParams:(point,object,instanceId)=>{
        set((state)=>({
            objectDetails:state.clickType === 'info' 
            ? (instanceId 
                ? (object.userData.instancesData ? object.userData.instancesData[instanceId] : null) 
                : (object.userData.displayData ? object.userData.displayData : null)
              ) 
            : null,
            objectDetailsPosition:(state.clickType==='info' && (object.userData.displayData||object.userData.instancesData))?point:null,
            objectDetailsObject:(state.clickType==='info' && (object.userData.displayData||object.userData.instancesData))?object:null,
            measure_points:(state.clickType==='distance' && state.measure_points.length<2)?[...state.measure_points,point]:(state.clickType==='distance'? [point]:[]),
            zoomPosition:(state.clickType==='zoom')?point:null,
            clickType:(state.clickType==='zoom')?'pan':state.clickType,
            colorMaterial:(state.clickType==='color')?object.material:null,
            currentObjectName:object.name,
            instanceId:state.clickType === 'info'?(instanceId?instanceId:null):null
        }))
    },
    instanceId:null,
    objectDetails:'',
    objectDetailsPosition:null,
    objectDetailsObject:null,
    zoomPosition:null,
    colorMaterial:null,
    currentObjectName:null,
    zoomToExtent:false,
    setZoomToExtent:(z)=>set({zoomToExtent:z}),
    showLabels:false,
    setLabels:()=>set((state)=>({showLabels:!state.showLabels})),
    showMeasurements:false,
    setShowMeasurements:(show)=>set({showMeasurements:show}),
    toggleMeasurements:()=>set((state)=>({showMeasurements:!state.showMeasurements})),
    blockModelLegends: {},
    setBlockModelLegend: (name, grade, visible) =>
      set((state) => {
        const next = { ...state.blockModelLegends };
        if (visible) {
          next[name] = grade || '';
        } else {
          delete next[name];
        }
        return { blockModelLegends: next };
      }),
    blockModelOpacity: 1,
    setBlockModelOpacity: (opacity) => set({ blockModelOpacity: opacity }),
    blockModelGradeRange: { min: null, max: null },
    setBlockModelGradeRange: (range) => set({ blockModelGradeRange: range }),
    blockModelGradeFilter: { min: null, max: null },
    setBlockModelGradeFilter: (range) => set({ blockModelGradeFilter: range }),
    selectionRegion: null,
    setSelectionRegion: (region) => set({ selectionRegion: region }),
    pinnedInfos: [],
    addPinnedInfo: (info) =>
      set((state) => ({ pinnedInfos: [...state.pinnedInfos, info] })),
    removePinnedInfo: (id) =>
      set((state) => ({ pinnedInfos: state.pinnedInfos.filter((item) => item.id !== id) })),
    clearPinnedInfos: () => set({ pinnedInfos: [] }),
    isFlyAroundActive:false,
    setFlyAround:(active)=>set({isFlyAroundActive:active})

}));

export const useInforStore = create((set)=>({
    info:'...',
    setInfo:(info_)=>set({info:info_})
}));

